import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  inject,
} from '@angular/core';
import { Store } from '@ngxs/store';
import {
  Activity,
  COMPACT_ABSENCE_HEIGHT,
  GroupedUserData,
  Shift,
  ShiftAssignment,
  UserTimelines,
  UserTimelinesModal,
} from '@wilson/interfaces';
import {
  GanttChartTimeDifferenceComponent,
  SelectedItemOutput,
  ToDateTimeRangePipe,
} from '@wilson/shift-timeline/assignments-gantt-chart';
import {
  ModalInteractionService,
  MoveAbsenceDropZoneHelperService,
  TimelineAutoSizeUserShiftsComponent,
  TimelineUserAbsenceComponent,
} from '@wilson/shift-timeline/core';
import {
  MODAL_VIEW,
  ShiftAssignmentModalState,
} from '@wilson/shift-timeline/state';
import { Observable } from 'rxjs';
import { ShiftToAssignCardComponent } from '../shift-to-assign-card/shift-to-assign-card.component';
import { TimelineFilterShiftToAssignPipe } from '../../pipes/timeline-filter-shift-to-assign.pipe';
import { FindStaffGanttChartService } from '../services/find-staff-gantt-chart.service';

@Component({
  selector: 'wilson-timeline-modal-user-view',
  templateUrl: './timeline-modal-user-view.component.html',
  styleUrls: ['./timeline-modal-user-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    GanttChartTimeDifferenceComponent,
    TimelineUserAbsenceComponent,
    TimelineAutoSizeUserShiftsComponent,
    ToDateTimeRangePipe,
    ShiftToAssignCardComponent,
    TimelineFilterShiftToAssignPipe,
  ],
  providers: [MoveAbsenceDropZoneHelperService],
})
export class TimelineModalUserViewComponent implements OnInit {
  private readonly store = inject(Store);
  modalInteractionService = inject(ModalInteractionService);
  findStaffGanttChartService = inject(FindStaffGanttChartService);

  @Input() user!:
    | (UserTimelines & {
        shiftAssignment: ShiftAssignment | undefined;
      })
    | UserTimelinesModal;
  @Input() userIndex!: number;
  @Input() userData!: { rows: GroupedUserData[] };
  @Input() mouseOverRowIndex!: number | null;
  public defaultRowHeight$!: Observable<number>;
  public shiftToAssign$!: Observable<
    (Shift & { activities: Activity[] }) | null
  >;
  public activitiesToAssign$!: Observable<Activity[] | null>;
  public modalView$!: Observable<MODAL_VIEW>;
  MODAL_VIEW = MODAL_VIEW;
  COMPACT_ABSENCE_HEIGHT = COMPACT_ABSENCE_HEIGHT;

  ngOnInit(): void {
    this.shiftToAssign$ = this.store.select(
      ShiftAssignmentModalState.shiftToAssign,
    );
    this.activitiesToAssign$ = this.store.select(
      ShiftAssignmentModalState.activitiesToAssign,
    );
    this.modalView$ = this.findStaffGanttChartService.modalView$;
    this.defaultRowHeight$ =
      this.findStaffGanttChartService.ganttChartDefaultRowHeight$;
  }

  redirectToShiftDetails(event: SelectedItemOutput): void {
    const route = `/shifts/${event.id}`;
    window.open(route, '_blank');
  }
}
